// test1772
(1772 && 0);
